export const removeUrlQueryParams = () =>
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname + window.location.hash
    );